import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core'
import { Subject, takeUntil } from 'rxjs'

import { PrimeNGConfig } from 'primeng/api'
import { Subscription } from 'rxjs'

import { environment } from 'src/environments/environment'
import { AppVersionUpdateService } from './data/services/application/app-version-update/app-version-update.service'
import { GoogleCalendarOAuthPopupService } from './data/services/erp/google-calendar/google-calendar-oauth-popup.service'
import { PulsarWebSocketService } from './data/services/application/pulsar-websocket/pulsar-websocket.service'
import { ToastService } from './data/services/components/toast/toast.service'
import { ThemeService } from './data/services/application/theme/theme.service'
import { UserService } from './data/services/application/user/user.service'
import { Theme } from './domain/enums/application/theme.enum'
import { TypeMessageTape } from './domain/enums/components/message-tape.enum'
import { ToastSeverity } from './domain/enums/components/toast.enum'
import { Toast } from './domain/interfaces/components/toast.interface'
import { isExternalRoute } from './domain/utils/functions/is-external-route'
import { AuthService } from './infra/auth/auth.service'
import { pt_BR } from './infra/translations/pt_BR.translation'
@Component({ selector: 'app-root', templateUrl: './app.component.html', styleUrls: ['./app.component.scss'] })
export class AppComponent implements OnInit, OnDestroy {
  private primengConfig: PrimeNGConfig = inject(PrimeNGConfig)
  private themeService: ThemeService = inject(ThemeService)
  private authService: AuthService = inject(AuthService)
  private pulsarWebSocketService: PulsarWebSocketService = inject(PulsarWebSocketService)
  private userService: UserService = inject(UserService)
  private toastService: ToastService = inject(ToastService)
  private googleCalendarOAuthPopupService: GoogleCalendarOAuthPopupService = inject(GoogleCalendarOAuthPopupService)
  private appVersionUpdateService: AppVersionUpdateService = inject(AppVersionUpdateService)

  private googleCalendarOAuthSubscription: Subscription | null = null
  private destroy$ = new Subject<void>()

  title: string = 'frontend'
  selectedTheme: Theme = Theme.DEFAULT

  typeMessageTape: TypeMessageTape = TypeMessageTape.DEFAULT

  isShowTape: boolean = false
  isShowOfflineScreen: boolean = false
  isShowVersionUpdate: boolean = false

  tapeMessage: string = ''

  constructor(private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    if (!environment.production) {
      console.log('environment:', environment.default)
    }

    this.primengConfig.ripple = true
    this.primengConfig.setTranslation(pt_BR)

    this.appVersionUpdateService.start()
    this.appVersionUpdateService.isShow$.pipe(takeUntil(this.destroy$)).subscribe((isShow) => {
      this.isShowVersionUpdate = isShow
      this.cdr.detectChanges()
    })

    this.themeService.themeSubject.pipe(takeUntil(this.destroy$)).subscribe((selectedTheme: Theme) => (this.selectedTheme = selectedTheme))

    if (!isExternalRoute()) {
      this.authService.startIddle()

      this.pulsarWebSocketService.connect()
      this.pulsarWebSocketService.isOffline$.pipe(takeUntil(this.destroy$)).subscribe((isOffline) => {
        this.isShowOfflineScreen = isOffline
        this.cdr.detectChanges()
      })
      this.pulsarWebSocketService.authError$.pipe(takeUntil(this.destroy$)).subscribe(() => this.userService.logout())

      window.addEventListener('storage', this.handleStorage)
    }

    this.googleCalendarOAuthPopupService.init()
    this.googleCalendarOAuthSubscription = this.googleCalendarOAuthPopupService.result$.subscribe((result) => {
      if (result === 'success') this.toastService.sendToast({ severity: ToastSeverity.SUCCESS, message: 'Google Agenda conectado com sucesso!' } as Toast)
      else this.toastService.sendToast({ severity: ToastSeverity.ERROR, message: 'Falha ao conectar com o Google Agenda.' } as Toast)
      this.cdr.detectChanges()
    })
  }

  public ngOnDestroy(): void {
    this.googleCalendarOAuthSubscription?.unsubscribe()
    this.destroy$.next()
    this.destroy$.complete()
    window.removeEventListener('storage', this.handleStorage)
  }

  private handleStorage = (event: StorageEvent): void => {
    if (event.key === 'token' && event.newValue === null) this.userService.logout()
  }
}
